/** Shared date/phone formatting for the Practice section. */

const DAY_MS = 86_400_000;

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate());

/** "3 Aug" — short human date. */
export function fmtDay(d?: string | null): string {
  if (!d) return '';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
}

/** "Today" / "Tomorrow" / "3 Aug" — for hearing and due dates. */
export function dayLabel(d?: string | null): string {
  if (!d) return '';
  const date = new Date(d);
  if (isNaN(date.getTime())) return '';
  const diff = Math.round(
    (startOfDay(date).getTime() - startOfDay(new Date()).getTime()) / DAY_MS
  );
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Tomorrow';
  if (diff === -1) return 'Yesterday';
  return fmtDay(d);
}

/** True when the date is strictly before today (calendar days). */
export function isOverdue(d?: string | null): boolean {
  if (!d) return false;
  const date = new Date(d);
  if (isNaN(date.getTime())) return false;
  return startOfDay(date).getTime() < startOfDay(new Date()).getTime();
}

/** wa.me deep link — strip non-digits, prefix 91 for bare 10-digit numbers. */
export function waLink(phone: string): string {
  let digits = phone.replace(/\D/g, '');
  if (digits.length === 10) digits = `91${digits}`;
  return `https://wa.me/${digits}`;
}
